import { Badge, createStyles, Divider, Group } from '@mantine/core';

import React, { useCallback, useState, useRef } from 'react';
import { ApprovalEventTypes } from '../ApprovalModule';

import SingleLayout from './SingleLayout';
import OpenSeadragon from 'openseadragon';
import { logger } from 'utils/logger';

const useStyles = createStyles((theme, _params, getRef) => ({
    '.approvaltoolbar':{
        root: {
            background:'red'
        }
    },   
    layoutWrapper:{
      flexGrow:'1 !important',
      height:'100%',
      maxWidth:'calc(50% - 16px)',
      position:'relative',
      '&.selected':{
        '.layoutImage':{
            border:theme.colorScheme === 'dark' ? `1px solid ${theme.colors.brand[2]}` : `1px solid ${theme.colors.brand[3]}`
        }        
      }
    },
    imageBadge:{
        position:'absolute',
        top:theme.spacing.xs,
        left:theme.spacing.xs,
    }   

  }));

const CompareLayout = ({onImageEvent, comparisonItems, selectedItems, selectedItem, selectedFrame, settings, onCaptureChange, settingsChange}) => {

    const { classes } = useStyles();

    const img1 = comparisonItems && comparisonItems[0]?comparisonItems[0]:null;
    const img2 = comparisonItems && comparisonItems[1]?comparisonItems[1]:null;

    const [viewer1, setViewer1] = useState(null);
    const [viewer2, setViewer2] = useState(null);
    
    // Prevent infinite sync loops
    const syncingRef = useRef(false);
    const lastViewportRef = useRef(null);
    
    const handleViewportChange = (viewportData) => {
      if (!settings.syncZoomPan || syncingRef.current) return;
      
      // Debounce rapid pan events
      const viewportKey = `${viewportData.zoom}-${viewportData.center.x}-${viewportData.center.y}`;
      if (lastViewportRef.current === viewportKey) return;
      lastViewportRef.current = viewportKey;
      
      logger.log('viewportData', viewportData.eventType);
      
      // Determine which viewer to sync
      const sourceViewer = viewportData.sourceInstanceId === 'openSeaDragon1' ? viewer1 : viewer2;
      const targetViewer = viewportData.sourceInstanceId === 'openSeaDragon1' ? viewer2 : viewer1;
      
      if (sourceViewer && targetViewer) {
        syncingRef.current = true;
        
        // Apply same viewport to target viewer
        if (viewportData.eventType === 'pan') {
          // For panning, use panTo with the center point
          targetViewer.viewport.panTo(
            new OpenSeadragon.Point(viewportData.center.x, viewportData.center.y),
            false // immediate: false for smooth animation
          );
        } else if (viewportData.eventType === 'zoom') {
          // For zooming, first set the zoom level, then center the view
          targetViewer.viewport.zoomTo(viewportData.zoom, null, false);
          // Then center the view at the same relative position
          const centerPoint = new OpenSeadragon.Point(viewportData.center.x, viewportData.center.y);
          targetViewer.viewport.panTo(centerPoint, false);
        } else {
          // For rotation or other events, update both zoom and center
          targetViewer.viewport.zoomTo(
            viewportData.zoom, 
            new OpenSeadragon.Point(viewportData.center.x, viewportData.center.y),
            false // immediate: false for smooth animation
          );
        }
        
        // Reset syncing flag after a short delay
        setTimeout(() => {
          syncingRef.current = false;
        }, 25); // Reduced from 50ms to 25ms for faster response
      }
    };

    return (
    // display debug info for the viewport data
   <>
   
   
        <Group sx={{width:'100%', flexGrow:1, height:'100%', gap:0}} px={'md'}>
            <div className={`${classes.layoutWrapper} ${selectedFrame === 0?'selected':''}`} onClick={() => onImageEvent(ApprovalEventTypes.COMPARE_FRAME_CLICK,{image:comparisonItems[0],index:0})}>
                <SingleLayout onViewerReady={setViewer1} onViewportChange={handleViewportChange} image={img1} instanceId='openSeaDragon1' settings={settings} settingsChange={settingsChange} onCaptureChange={(type,data,items) => onCaptureChange(type,data,[comparisonItems[0]])} />
                <Badge radius='xl' size='xs' variant="gradient" gradient={{ from: '#ed6ea0', to: '#ec8c69', deg: 35 }} className={classes.imageBadge}>1</Badge>
            </div>
            <div style={{width:32, height:'100%', flexGrow:0, display:'flex'}}>
            <Divider orientation="vertical" sx={{width:1,marginTop:-16, marginBottom:-16}} mx='md' />
            </div>
            
            <div className={`${classes.layoutWrapper} ${selectedFrame === 1?'selected':''}`} onClick={() => onImageEvent(ApprovalEventTypes.COMPARE_FRAME_CLICK,{image:comparisonItems[1],index:1})}>
                <SingleLayout onViewerReady={setViewer2} onViewportChange={handleViewportChange} image={img2} instanceId='openSeaDragon2' settings={settings} settingsChange={settingsChange} onCaptureChange={(type,data,items) => onCaptureChange(type,data,[comparisonItems[1]])} />
                <Badge radius='xl' size='xs' variant="gradient" gradient={{ from: '#ed6ea0', to: '#ec8c69', deg: 35 }} className={classes.imageBadge}>2</Badge>
            </div>
        </Group>
        </>

    )
}

export default CompareLayout;

